import { render, staticRenderFns } from "./StaticContentItemTile.vue?vue&type=template&id=46a11ea9&scoped=true"
import script from "./StaticContentItemTile.vue?vue&type=script&lang=js"
export * from "./StaticContentItemTile.vue?vue&type=script&lang=js"
import style0 from "./StaticContentItemTile.vue?vue&type=style&index=0&id=46a11ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a11ea9",
  null
  
)

export default component.exports